import { cn } from "@/lib/cn";
import type { BucketDef } from "./constants";

interface Props {
  def: BucketDef;
  count: number;
  children: React.ReactNode;
}

const TONE_TEXT: Record<BucketDef["tone"], string> = {
  destructive: "text-destructive",
  amber: "text-warning-foreground",
  primary: "text-primary",
  muted: "text-muted-foreground",
};

export function TaskBucketGroup({ def, count, children }: Props) {
  const Icon = def.icon;
  return (
    <section className="space-y-2">
      <h2 className={cn("flex items-center gap-2 text-xs font-semibold uppercase tracking-wider", TONE_TEXT[def.tone])}>
        <Icon className="w-3.5 h-3.5" aria-hidden /> {def.label}
        <span className="text-muted-foreground font-normal">({count})</span>
      </h2>
      <div className="space-y-1.5">{children}</div>
    </section>
  );
}
